module.exports = __webpack_public_path__ + "media/assets/images/curation/line-c5b45f855144282ea52044d21ef89fdd.svg";